import { newSpecPage } from '@stencil/core/testing'
import { CobaltLink } from '../cobalt-link'

describe('cobalt-link', () => {
  it('should render link element', async () => {
    const page = await newSpecPage({
      components: [CobaltLink],
      html: '<cobalt-link href="#" link-title="title" label="Link"></cobalt-link>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-link href="#" label="Link" link-title="title">
        <core-link href="#" label="Link" linktitle="title" size="medium" variant="primary"></core-link>
      </cobalt-link>
    `)
  })
  it('should render link element with icon', async () => {
    const page = await newSpecPage({
      components: [CobaltLink],
      html: '<cobalt-link href="#" link-title="title" label="Link" icon-name="chevron_right-outline"></cobalt-link>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-link href="#" icon-name="chevron_right-outline" label="Link" link-title="title">
        <core-link href="#" iconname="chevron_right-outline" label="Link" linktitle="title" size="medium" variant="primary"></core-link>
      </cobalt-link>
    `)
  })
  it('should be able to use link as wrapper', async () => {
    const page = await newSpecPage({
      components: [CobaltLink],
      html: '<cobalt-link router-link size="medium"><a href="#" title="title">Label</a></cobalt-link>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-link router-link="" size="medium">
        <core-link routerlink="" size="medium" variant="primary">
          <a class="core-anchor typography-body-medium-bold" href="#" title="title">
            Label
          </a>
        </core-link>
      </cobalt-link>
    `)
  })
})
